require('../modules/es7.global');
module.exports = require('../modules/_core').global;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/global.js
// module id = 410
// module chunks = 17